import React from "react";
import { stats } from "../../data/content";
export function StatsStrip() {
  return <section className="bg-forest py-10 md:py-12" aria-label="At a glance" data-id="element-222" data-mp="289qsdtojetw5">
      <div className="mx-auto max-w-wrap px-5 md:px-8" data-id="element-223" data-mp="28buuq76sfkub">
        <div className="grid grid-cols-2 border border-white/15 md:grid-cols-4" data-id="element-224" data-mp="2m7yoy0hnvt6s">
          {stats.map((s, i) => <div key={s.label} className={`px-3 py-7 text-center md:py-9 ${i % 2 === 0 ? "border-r border-white/15" : ""} ${i < 2 ? "border-b border-white/15 md:border-b-0" : ""} md:border-r md:last:border-r-0`} data-id="element-225" data-mp="2i8g22z6a581b" data-mpi={i}>
              <div className="heading text-[44px] text-sand md:text-[56px]" data-id="element-226" data-mp="23bysacdqo1gv">{s.value}</div>
              <div className="mt-2 text-[11px] font-bold uppercase tracking-[0.14em] text-ivory md:text-xs" data-id="element-227" data-mp="1yivwrypeihy1">{s.label}</div>
            </div>)}
        </div>
      </div>
    </section>;
}